var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.664,
    height: 17.093,
    viewBox: "0 0 21.664 17.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.1 -44.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.749,47.432a2.308,2.308,0,0,0-1.693-.714H15.669v-.041a1.831,1.831,0,0,0-.551-1.326,1.865,1.865,0,0,0-1.326-.551H7.671a1.881,1.881,0,0,0-1.9,1.877v.041H2.408a2.308,2.308,0,0,0-1.693.714A2.426,2.426,0,0,0,0,49.125V59.286a2.308,2.308,0,0,0,.714,1.693,2.426,2.426,0,0,0,1.693.714H19.056a2.308,2.308,0,0,0,1.693-.714,2.426,2.426,0,0,0,.714-1.693V49.125A2.308,2.308,0,0,0,20.749,47.432ZM20.4,59.286h-.02a1.324,1.324,0,0,1-1.326,1.326H2.408a1.323,1.323,0,0,1-1.326-1.326V49.125A1.323,1.323,0,0,1,2.408,47.8H6.345a.549.549,0,0,0,.551-.551v-.592a.768.768,0,0,1,.8-.8h6.1a.768.768,0,0,1,.8.8v.592a.548.548,0,0,0,.551.551h3.938A1.324,1.324,0,0,1,20.4,49.125Z",
    transform: "translate(0 -44.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.819,59.236a5.019,5.019,0,1,0,3.55,8.569,5.019,5.019,0,0,0-3.55-8.569Zm2.775,7.814a3.941,3.941,0,0,1-5.55,0A3.9,3.9,0,0,1,19.9,64.275,3.988,3.988,0,0,1,21.044,61.5a3.9,3.9,0,0,1,2.775-1.143A3.988,3.988,0,0,1,26.594,61.5a3.9,3.9,0,0,1,1.143,2.775A3.818,3.818,0,0,1,26.594,67.05Z",
    transform: "translate(-13.087 -54.849)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bae9bbef.svg";
export { ForwardRef as ReactComponent };